import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewCycles (){
  const {user} = useUser()
  let view = contentLayout[modules.CyclesList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.CyclesList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.CyclesList}></Index>
 )
}

export default ViewCycles
